<div id="date-exception" *ngIf="exceptionResolution?.expanded">
  <div class="alert-message" data-cy="date-exception-message-text">
    <ion-icon name="alert-circle-outline" class="alert-icon"></ion-icon>
    {{ exceptionResolution?.orderException?.errorMessage }}
  </div>
  <div class="product-row">
    <div data-cy="date-exception-delivery-date-text">
      {{ 'i18n.orderExceptionsPage.validDeliveryDate' | translate }}
    </div>

    <ion-button
      [ngClass]="
        !orderHeader?.confirmedDeliveryDate
          ? 'usf-fill-disabled-button'
          : 'usf-fill-green-button'
      "
      (click)="confirm()"
      data-cy="apply-date-button"
      disabled="{{ !orderHeader?.confirmedDeliveryDate }}"
      >{{ 'i18n.common.apply' | translate }}</ion-button
    >
  </div>
  <div>
    <ion-button
      class="usf-outline-green-button"
      data-cy="confirm-delivery-date-button"
      (click)="emitUpdateDate()"
    >
      <span>
        <ion-icon name="calendar-outline"></ion-icon>
      </span>
      &nbsp;&nbsp;
      {{
        exceptionResolution?.resolutionDate ||
          orderHeader?.confirmedDeliveryDate | date: 'M/d/yyyy' : 'GMT'
      }}
    </ion-button>
  </div>
</div>

<div id="banner" *ngIf="!exceptionResolution?.expanded">
  <div class="banner-title" data-cy="banner-date-applied-title">
    {{ 'i18n.common.applied' | translate }}
  </div>
  <div class="date-completed-info">
    <div data-cy="banner-date-order-number-text">
      {{ 'i18n.orderExceptionsPage.orderNumber' | translate }}
      {{ orderHeader?.tandemOrderNumber }}
    </div>
    <div data-cy="banner-delivery-date-text">
      {{ 'i18n.orderExceptionsPage.deliveryDate' | translate }}
      <span>{{
        selectedDate || this.orderHeader?.confirmedDeliveryDate
          | date: 'M/d/yyyy' : 'GMT'
      }}</span>
    </div>
  </div>
  <div class="edit-link" (click)="edit()" data-cy="edit-date-banner-button">
    {{ 'i18n.common.edit' | translate }}
  </div>
</div>
